import { CheckCircle2, XCircle, RefreshCw, SkipForward } from 'lucide-react';

const STATUS_ICON = {
  created: { Icon: CheckCircle2, className: 'text-greenColor' },
  enriched: { Icon: RefreshCw, className: 'text-purpleColor' },
  overwritten: { Icon: RefreshCw, className: 'text-orangeColor' },
  skipped: { Icon: SkipForward, className: 'text-darkGrayColor' },
  failed: { Icon: XCircle, className: 'text-redColor' },
};

const fmtTime = (ts) => {
  if (!ts) return '';
  try {
    return new Date(ts).toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  } catch {
    return '';
  }
};

// Bottom-of-ProgressStep feed: last 5 processed items, newest first.
export const LiveActivityFeed = ({ items = [] }) => {
  if (!items.length) {
    return (
      <div data-testid="progress-activity-feed" className="text-xs text-darkGrayColor py-3 text-center">
        Waiting for the first records…
      </div>
    );
  }

  return (
    <ul data-testid="progress-activity-feed" className="flex flex-col gap-1.5">
      {items.map((item) => {
        const spec = STATUS_ICON[item.status] || STATUS_ICON.skipped;
        const { Icon } = spec;
        return (
          <li
            key={`${item.parser_advert_id}-${item.updated_at}`}
            data-testid={`progress-activity-item-${item.parser_advert_id}`}
            className="flex items-start gap-2 px-2 py-1.5 rounded border border-gray-100 bg-white hover:bg-lightestGrayColor transition-colors"
          >
            <Icon size={14} className={spec.className + ' mt-0.5 flex-shrink-0'} />
            <div className="flex-1 min-w-0">
              <div className="flex items-baseline justify-between gap-2">
                <span className="text-xs font-medium text-blackColor truncate">
                  {item.title || `advert #${item.parser_advert_id}`}
                </span>
                <span className="text-[10px] text-darkGrayColor whitespace-nowrap">
                  {fmtTime(item.updated_at)}
                </span>
              </div>
              <div className="flex items-center gap-2 text-[10px] text-darkGrayColor">
                <span className={'font-medium ' + spec.className}>
                  {item.status}
                </span>
                {item.duration_ms != null && (
                  <span>{item.duration_ms} ms</span>
                )}
                {item.realty_id && (
                  <span>· realty #{item.realty_id}</span>
                )}
                {item.error && (
                  <span className="text-redColor truncate" title={item.error}>
                    · {item.error}
                  </span>
                )}
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};
